import { render } from "./HomeFacilitiesView.vue?vue&type=template&id=b403bd64&scoped=true"
import script from "./HomeFacilitiesView.vue?vue&type=script&lang=js"
export * from "./HomeFacilitiesView.vue?vue&type=script&lang=js"

import "./HomeFacilitiesView.vue?vue&type=style&index=0&id=b403bd64&scoped=true&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b403bd64"]])

export default __exports__